import { render, staticRenderFns } from "./index_p.vue?vue&type=template&id=3cc6ce80&scoped=true"
import script from "./index_p.vue?vue&type=script&lang=js"
export * from "./index_p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6ce80",
  null
  
)

export default component.exports